import { html } from "lit";
var icon_aws_default = () => html`
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
    <path
      d="M3.178 9.515a.566.566 0 01.747-.544l10.186 3.396c.229.077.383.29.385.532v15.29a.566.566 0 01-.747.533l-10.118-3.52a.566.566 0 01-.385-.532L3.178 9.515zm14.714 18.732a.566.566 0 00.758.531l10.187-3.565a.566.566 0 00.373-.532V9.605a.566.566 0 00-.735-.543l-10.187 3.237a.566.566 0 00-.396.543v15.405zM16.024 9.798c.1.028.206.028.306 0l9.824-2.694a.566.566 0 100-1.132L16.33 3.21a.566.566 0 00-.306 0L6.336 5.813a.566.566 0 100 1.132l9.688 2.853z" />
  </svg>
`;
export {
  icon_aws_default as default
};
//# sourceMappingURL=icon-aws.js.map
